import './embed-youtube-video.scss';
import {Box} from '@mui/material';

/**
 * Embed youtube video.
 *
 * Note: It assumes the url will come in the format "https://www.youtube.com/watch?v=YYYYYYYY"
 * because it's how the URLs are stored in the database for now and show it inside an iframe.
 * Otherwise, it uses the given URL and a video tag is used.
 */
export const EmbedYoutubeVideo = (props: {url: string; title: string}) => {
  const searchString: string = 'watch?v=';
  const embedIdIndex: number = props.url.indexOf(searchString);
  const embedUrl: string =
    embedIdIndex !== -1
      ? `https://www.youtube.com/embed/${props.url.substring(embedIdIndex + searchString.length)}`
      : props.url;

  return (
    <Box className="embed-youtube-video-container">
      {embedIdIndex !== -1 ? (
        <iframe
          className="embed-youtube-video-video"
          src={embedUrl}
          title={props.title}
          frameBorder="0"
          allowFullScreen
        />
      ) : (
        <video className="embed-youtube-video-video" controls>
          <source src={embedUrl} />
        </video>
      )}
    </Box>
  );
};
